'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'name': '@okta/okta-react',
  'version': '3.0.1'
};